import React, { forwardRef } from 'react';

export const HelpCenterSSOForm = forwardRef(({ inputRef }, formRef) => {
  return (
    <form
      className="gst-hidden"
      ref={formRef}
      action={null}
      method="post"
    >
      <input ref={inputRef} type="hidden" name="jwt" />
    </form>
  );
});

HelpCenterSSOForm.displayName = 'HelpCenterSSOForm';
